import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const FloatingHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  cursor: move;
  background: ${({ theme }) => theme.colorPalette.turquoise.dark};
  user-select: none;
  transition: all 0.3s ease;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FloatingTitle = styled.h3`
  color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.white)};
  font-size: ${({ theme }) => theme.fontSizePalette.xLarge};
  margin-bottom: 0;
  cursor: move;
`;

export const Buttons = styled.div`
  display: flex;
  gap: 10px;
`;

export const IconButton = styled.div`
  width: 36px;
  height: 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.white)};

  border-radius: 50%;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const ResetButton = styled.div`
  padding: 5px 9px;
  border-radius: 15px;
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.dark : theme.colorPalette.white};
  border: 1px solid
    ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.grey.grey5)};
  cursor: pointer;
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.normal};
`;

export const HoverResizeHandle = styled.div<{ isHovered: boolean }>`
  position: absolute;
  width: 16px;
  height: 16px;
  z-index: 1001;
  background-color: #a0d4dc;
  transition: all 0.2s ease;
  top: 0;
  left: 0;
  cursor: nw-resize;
  opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
  transition: opacity 0.2s ease;

  &:hover {
    background-color: #319aa6;
    transform: scale(1.1);
  }

  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: #2a7f8a;
    top: 4px;
    left: 4px;
  }
`;
